import React, { useState } from 'react';
import { COVER_BG_IMAGE } from '../constants/cover';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../services/api';
import { useLanguage } from '../context/LanguageContext';

const AdminLogin = () => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { t, language } = useLanguage();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await authAPI.login(credentials);
      localStorage.setItem('token', response.data.token);
      navigate('/admin/dashboard');
    } catch (err) {
      setError(language === 'ar' ? 'اسم المستخدم أو كلمة المرور غير صحيحة' : 'Identifiants invalides');
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>{t('login')}</h2>
        <p style={styles.subtitle}>
          {language === 'ar' ? 'لوحة التحكم الإدارية' : 'Panneau d\'administration'}
        </p>

        {error && <div style={styles.error}>{error}</div>}
        
        <form onSubmit={handleSubmit} style={styles.form}>
          <input
            type="text"
            placeholder={t('username')}
            value={credentials.username}
            onChange={(e) => setCredentials({...credentials, username: e.target.value})}
            style={styles.input}
            required
            autoComplete="username"
          />
          <input
            type="password"
            placeholder={t('password')}
            value={credentials.password}
            onChange={(e) => setCredentials({...credentials, password: e.target.value})}
            style={styles.input}
            required
            autoComplete="current-password"
          />
          <button type="submit" style={styles.button}>
            {language === 'ar' ? 'تسجيل الدخول' : 'Se connecter'}
          </button>
        </form>
        
        {/* Security Note */}
        <div style={styles.securityNote}>
          <p style={styles.noteText}>
            {language === 'ar' 
              ? '🔒 تسجيل الدخول آمن ومشفر' 
              : '🔒 Connexion sécurisée et cryptée'}
          </p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundImage: `linear-gradient(135deg, rgba(26, 54, 93, 0.52) 0%, rgba(44, 82, 130, 0.48) 100%), url(${COVER_BG_IMAGE})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    padding: '20px'
  },
  card: {
    background: 'white',
    padding: '40px',
    borderRadius: '20px',
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
    width: '100%',
    maxWidth: '450px'
  },
  title: {
    textAlign: 'center',
    marginBottom: '10px',
    color: '#1a365d',
    fontSize: '32px',
    fontWeight: 'bold'
  },
  subtitle: {
    textAlign: 'center',
    marginBottom: '30px',
    color: '#666',
    fontSize: '16px'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px'
  },
  input: {
    padding: '15px',
    border: '2px solid #ddd',
    borderRadius: '10px',
    fontSize: '16px',
    transition: 'border-color 0.3s'
  },
  button: {
    padding: '15px',
    background: '#1a365d',
    color: 'white',
    border: 'none',
    borderRadius: '10px',
    fontSize: '18px',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'background 0.3s'
  },
  error: {
    background: '#ffebee',
    color: '#c62828',
    padding: '12px',
    borderRadius: '8px',
    marginBottom: '15px',
    textAlign: 'center',
    fontWeight: '600'
  },
  securityNote: {
    marginTop: '20px',
    textAlign: 'center',
    padding: '15px',
    background: '#f5f5f5',
    borderRadius: '8px'
  },
  noteText: {
    fontSize: '14px',
    color: '#666',
    margin: 0
  }
};

export default AdminLogin;
